//AbstractZimbraInstanceSearch
import { HttpParams }   from '@angular/common/http';
import BaseSearch       from './BaseSearch';
import { FormControl }  from '@angular/forms';

export default class AbstractZimbraInstanceSearch extends BaseSearch
{
        code   :  string;
        name   :  string;
        url   :  string;
        auth_token   :  string;
    
    constructor(dict = null)
    {
        super(dict);
        if (dict !== null)
        {
            this.code = dict["code"]            || null;
            this.name = dict["name"]            || null;
            this.url = dict["url"]            || null;
            this.auth_token = dict["auth_token"]            || null;
        }
    }
    
    abstractBuildHttpParams()
    {
      var params = super.buildHttpParams()
      
      if (this.id !== null && this.id !== undefined) { params = params.set('id', this.id.toString()); }
      if (this.code !== null && this.code !== undefined) { params = params.set('code', this.code.toString()); }
      if (this.name !== null && this.name !== undefined) { params = params.set('name', this.name.toString()); }
      if (this.url !== null && this.url !== undefined) { params = params.set('url', this.url.toString()); }
      if (this.auth_token !== null && this.auth_token !== undefined) { params = params.set('auth_token', this.auth_token.toString()); }
      
      return params;
    }
}
